var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.fullscreenloading,
          expression: "fullscreenloading",
        },
      ],
      staticClass: "app-container",
    },
    [
      _c(
        "el-form",
        [
          _vm.displayType === "create"
            ? _c("div", [
                _vm._v(
                  "\n      Set the organization name and domain and save before uploading a logo.\n    "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.displayType === "edit"
            ? _c(
                "el-form-item",
                { attrs: { label: "ID:" } },
                [
                  _c("el-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.organizationForm.id,
                      callback: function ($$v) {
                        _vm.$set(_vm.organizationForm, "id", $$v)
                      },
                      expression: "organizationForm.id",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "el-form-item el-form-item--medium" }, [
            _c("label", { staticClass: "el-form-item__label" }, [
              _vm._v("NAME"),
              _c("span", { staticClass: "otr-red" }, [_vm._v("*")]),
              _vm._v(":"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "el-form-item__content" },
              [
                _c("el-input", {
                  attrs: { rows: 2, paceholder: "NAME" },
                  model: {
                    value: _vm.organizationForm.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.organizationForm, "name", $$v)
                    },
                    expression: "organizationForm.name",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
            _c(
              "label",
              { staticStyle: { color: "#606266", "line-height": "28px" } },
              [_vm._v("EMAIL DOMAINS:")]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { padding: "20px 0" } }, [
              _vm._v(
                "\n        If the user's email matches any of the domains, the system will associate her with the organization. List\n        email domains on separate lines.\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { width: "100%" } },
              [
                _vm._l(_vm.organizationForm.emailDomains, function (tag) {
                  return _c(
                    "el-tag",
                    {
                      key: tag,
                      attrs: { "disable-transitions": false, closable: "" },
                      on: {
                        close: function ($event) {
                          return _vm.handleClose(tag)
                        },
                      },
                    },
                    [_vm._v("\n          " + _vm._s(tag) + "\n        ")]
                  )
                }),
                _vm._v(" "),
                _vm.tagInputVisible
                  ? _c("el-input", {
                      ref: "saveTagInput",
                      staticClass: "input-new-tag",
                      on: { blur: _vm.handleTagInputConfirm },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleTagInputConfirm($event)
                        },
                      },
                      model: {
                        value: _vm.tagInputValue,
                        callback: function ($$v) {
                          _vm.tagInputValue = $$v
                        },
                        expression: "tagInputValue",
                      },
                    })
                  : _c(
                      "el-button",
                      {
                        staticClass: "button-new-tag",
                        on: { click: _vm.showTagInput },
                      },
                      [_vm._v("+ New domain")]
                    ),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm.displayType === "edit"
            ? _c("div", { staticClass: "el-form-item el-form-item--medium" }, [
                _c(
                  "label",
                  {
                    staticClass: "el-form-item__label",
                    staticStyle: { float: "none" },
                  },
                  [
                    _vm._v("ORGANIZATION LOGO: "),
                    _c(
                      "span",
                      [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top",
                              title: "ORGANIZATION LOGO",
                              trigger: "hover",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { "word-break": "normal" } },
                              [
                                _vm._v("\n              1. Height: 33px"),
                                _c("br"),
                                _vm._v("\n              2. Width: 200px"),
                                _c("br"),
                                _vm._v(
                                  "\n              3. Maximum file size: 5MB"
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n              4. Supported file format: PNG, JPEG"
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n              5. Must be a landscape logo"
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n              6. Logos larger than these dimensions will be scaled proportionally to fit within the designated area\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("svg-icon", {
                              attrs: { slot: "reference", "icon-class": "faq" },
                              slot: "reference",
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { margin: "10px 0" } }, [
                  _vm._v(
                    'After uploading or clearing image, please click "Save" button to make the change effective.'
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm.organizationForm.logo.url
                      ? _c("div", [
                          _vm.organizationForm.logo.url
                            ? _c("img", {
                                staticStyle: {
                                  "max-width": "300p",
                                  "max-height": "91px",
                                  border: "1px solid #dcdfe6",
                                },
                                attrs: { src: _vm.organizationForm.logo.url },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.organizationForm.logo = {}
                                },
                              },
                            },
                            [_vm._v("Clear")]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-row", { staticStyle: { padding: "15px 0" } }, [
                      _c("input", {
                        ref: "thumbfile",
                        staticStyle: { width: "300px" },
                        attrs: { accept: ".jpg,.jpeg,.png", type: "file" },
                        on: { change: _vm.chooseThumbnailFile },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.doThumbnailUpload()
                          },
                        },
                      },
                      [_vm._v(" Upload to preview")]
                    ),
                    _vm._v(" "),
                    _vm.showThumbnailUploadErrMsg
                      ? _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("otrResource.errMsgUploadFail"))
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "" } },
            [
              _vm.displayType === "create"
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: _vm.createButtonDisable,
                        type: "primary",
                      },
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.doAddSave($event)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("otrbutton.addSave")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.displayType === "edit"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.doSave($event)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("otrbutton.save")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-link",
                {
                  staticStyle: { "margin-left": "20px" },
                  attrs: { type: "info", href: "/#/organizations" },
                },
                [_vm._v("Back")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }